import React from 'react';
import {Folha} from '../../componentes/folha/folha';
const PaginaInicial = () => {
    return(<Folha>

        <h1>Bem Vindo</h1>
    </Folha>
    );
}

export {PaginaInicial};